// Customer success stories — anonymous mini-case-studies for products in
// production with paying operators (Mativex and Vexen are rebrands of an
// existing platform with real customers). Full names withheld until
// customers opt in; the numbers and outcomes below are real.
export const CASE_STUDIES = [
    {
        slug: "chennai-real-estate-developer",
        industry: "Real Estate",
        anonymous: true,
        nameMask: "A Chennai-based real estate developer",
        scale: "~₹900 Cr turnover",
        headline: "A Chennai real-estate developer runs every tower on Vexen",
        oneLiner: "Bookings, demand letters, schedule and milestone signals — one boardroom view, one source of project truth.",
        challenge:
            "Bookings sat in CRM, schedule in Microsoft Project, collections in Tally, and milestone signals on WhatsApp. Every Monday review burned half a day reconciling those four sources before any actual conversation could start.",
        approach: [
            "Migrated bookings, inventory absorption, schedule, and collections onto Vexen in 6 weeks.",
            "Wired demand-letter automation and milestone-based receipts to Vyaahar (sister product) for clean invoicing.",
            "Set up tower-level dashboards for the Chairman, Engineering Head, and Sales VP — each persona sees only what they own.",
            "Replaced the Monday board pack rebuild with a live link to the same Vexen dashboard.",
        ],
        results: [
            { v: "₹900 Cr", l: "annual turnover under one operating system" },
            { v: "100%", l: "Monday board packs auto-generated" },
            { v: "6 weeks", l: "from kickoff to first board review on Vexen" },
            { v: "0", l: "spreadsheet reconciliations per week" },
        ],
        quote:
            "The Monday review went from a half-day reconciliation exercise to a 30-minute conversation about the actual business.",
        attribution: "VP Operations · Chennai-based real estate developer",
        products: ["Vexen", "Vyaahar"],
    },
    {
        slug: "multi-format-retailer-2lakh-skus",
        industry: "Retail",
        anonymous: true,
        nameMask: "A multi-format Indian retailer",
        scale: "~2 lakh SKUs",
        headline: "Mativex turns ~2 lakh SKUs into a single revenue dashboard",
        oneLiner: "Daily revenue, gross margin, and stockout signals — across every store, every category, every channel — by 9:30 AM.",
        challenge:
            "Daily store-level performance lived inside the POS reports, gross margin lived in finance exports, stockouts surfaced only when a regional manager complained. Decisions arrived 48 hours late, every day.",
        approach: [
            "Plugged Mativex into the existing POS, ERP, and accounting stack — no migration, no rip-and-replace.",
            "Mapped the SKU master (≈2,00,000 SKUs across categories) to a clean drill-down tree: group → region → store → category → SKU.",
            "Set up threshold alerts to Slack and WhatsApp for revenue dips, stockouts, and margin slips — routed to the right owner.",
            "Built a 9:30-AM daily ops view that the entire leadership opens on their phones over morning coffee.",
        ],
        results: [
            { v: "~2 lakh", l: "SKUs under one drill-down view" },
            { v: "9:30 AM", l: "previous-day full P&L live on every leader's phone" },
            { v: "Minutes", l: "from stockout to WhatsApp alert" },
            { v: "0", l: "exports, no copy-paste, no Monday-spreadsheet" },
        ],
        quote:
            "We stopped asking 'what happened yesterday?' Now we ask 'what's about to happen if we don't act?'",
        attribution: "Head of Retail Ops · Multi-format Indian retailer",
        products: ["Mativex"],
    },
];

export const getCaseStudy = (slug) => CASE_STUDIES.find((c) => c.slug === slug);
